import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './executiveDashboardDetails.jade';
import Rx from 'rx';

export class ExecutiveDashboardDetailsController {
  /* @ngInject */
  constructor(Resource,ggTable,$filter,ggCSV) {
    this.translate = $filter('translate');
    this.MetricResource = Resource(`executive-analytics/${this.scopeName}-metric`, this.scopeName === 'engagement' ? {baseUrl: '/api/v2'} : {});
    this.MultimetricResource = Resource(`executive-analytics/${this.scopeName}-multimetric-opt`, {baseUrl: '/api/v2'});
    this.tableTotals = [];
    this.ggCSV = ggCSV;
    this.ggTable = ggTable;
    this.chartContextReadySubject = new Rx.Subject();

    this.query
      .distinctUntilChanged(JSON.stringify)
      .subscribe((query) => {
        this.getTableData(query);
        this.getExportTableData(query);
      });

    this.series = this.breakdownSeries.map((serie) => {
      return _.assign({}, serie, {
        type: 'spline',
        queryParams: {top_n: 20},
        transformResponse: ((res) => this.sortBreakdownSeriesAndSetExportData(res))
      });
    });

    this.seriesTable = new ggTable({
      count: 15,
      enableCalculateTotals: false
    });
  }

  getAggregationType(metric) {
    switch(metric) {
      case 'ctr':
      case 'ecpc':
      case 'ecpm':
        return 'avg';
      default:
        return 'sum';
    }
  }

  sortBreakdownSeriesAndSetExportData(res) {
    res = this.sortBreakdownSeries(res);
    return this.updateExportData(res);
  }

  sortBreakdownSeries(series) {
    let aggregationType = this.getAggregationType(_.get(series, '[0].query.metric'));
    return _.sortBy(series, (serie) => { return -serie.data.summary[aggregationType]; })
  }

  getTableData(query) {
    let params = _.merge({}, query, {top_n: 1000});
    this.MultimetricResource.one().get(params)
      .then((res) => {
        this.tableTotals = [];
        res = this.addIdToCampaignsAndSegmentsFields(res);
        this.updateTable(res.data);

        _.forEach(this.seriesTable.cols, (col) => this.tableTotals.push({field:res.totals[col.field], value:0, format:col.format}));

        _.forEach(this.seriesTable.cols, (col, index) => {
          if(index < this.nonMetricTableCols.length) {
            this.tableTotals[index].value = res.data.length;
          } else {
            this.tableTotals[index].value = res.totals[col.field];
          }
        });
      });
  }

  addIdToCampaignsAndSegmentsFields(res) {
    _.forEach(res.data, (row) => {
      if(row.segment_id) {
        row.segment_name = row.segment_id + ' - ' + row.segment_name;
      } else {
        row.campaign_name = row.campaign_id + ' - ' + row.campaign_name;
      }
    });
    return res;
  }

  getExportTableData(query) {
    this.chartContextReadySubject.onNext(false);
    let queryWithGroupByDate = _.merge({}, query, {group_by_date: true, top_n: 1000});

    this.MultimetricResource.one().get(queryWithGroupByDate)
      .then((res) => {
        this.tableDataGroupedByDate = this.addIdToCampaignsAndSegmentsFields(res);
        this.chartContextReadySubject.onNext(true);
      });
  }

  updateExportData(res) {
    if(!res.length) {return res;}

    let tableCols = this.nonMetricTableCols.concat(this.breakdownSeries.map((exploreMetric) => {
      return {
        field: exploreMetric.metric,
        filter: {[exploreMetric.metric]: 'text'},
        sortable: exploreMetric.metric,
        title: this.translate(exploreMetric.metric),
        format: exploreMetric.format,
        show: true
      }
    }));

    let csvFields = ['date'].concat(_.chain(tableCols).filter({show: true}).map('field').value());

    let csvData = [csvFields].concat(this.tableDataGroupedByDate.data.map((data) => {
      return _.chain(data).pick(csvFields).values().value();
    }));

    res[0].csvData = csvData;

    return res;
  }

  updateTable(data) {
    let tableCols = this.nonMetricTableCols.concat(this.breakdownSeries.map((exploreMetric) => {
      return {
        field: exploreMetric.metric,
        filter: {[exploreMetric.metric]: 'text'},
        sortable: exploreMetric.metric,
        title: this.translate(exploreMetric.metricForTranslation || exploreMetric.metric),
        format: exploreMetric.format,
        show: true
      }
    }));

    this.seriesTable.cols = tableCols;
    this.seriesTable.loadData(data);
  }
}

export function ExecutiveDashboardDetailsComponent() {
  return {
    template,
    controller: ExecutiveDashboardDetailsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      query: '=',
      scopeName: '@',
      breakdownSeries: '=',
      nonMetricTableCols: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.games.executiveSellingDetails', [
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('executiveDashboardDetails', ExecutiveDashboardDetailsComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/executiveDashboardDetails.js
 **/